import { IFacilityData } from "../administration/facilityData";
import { IUserData } from "../administration/userData";

export interface IPreplanRescue {
  id: number;
  facility: IFacilityData;
  facilityId: number;
  dateTimeAdd: Date;
  durationOfWork: string;
  reasonOfEntry: string;
  maintsRepOriginator: string;
  areaSTL: string;
  areaHO: string;
  hazardAssignments: string;
  descriptionConfinedSpace: string;
  spaceInformation: string;
  rescueTechDescription: string;
  portalSize: PortalSize;
  configuration: PreplanConfiguration;

  createdBy?: IUserData;
  createdById?: number;
  modifiedBy?: IUserData;
  modifiedById?: number;
  createdDate: Date;
  modifiedDate?: Date;

  // Grouped properties
  spaceCategory: ISpaceCategory;
  medicalPackingInfo: IMedicalPackingInfo;
  accessMethod: IAccessMethod;
  rescueMethodHaulSystem: IRescueMethodHaulSystem;
}

// Space Category
export interface ISpaceCategory {
  isRa: boolean;
  isRs: boolean;
}

// Medical Packing Information
export interface IMedicalPackingInfo {
  isLongSpineBoard: boolean;
  isKED: boolean;
  isStokesBasket: boolean;
  isBreathingAirRequired: boolean;
}

// Access Method
export interface IAccessMethod {
  isHorizontal: boolean;
  isVerticalTop: boolean;
  isVerticalBottom: boolean;
  isAccessElevated: boolean;
}

// Rescue Method Haul System
export interface IRescueMethodHaulSystem {
  isExternalRetrieval: boolean;
  isInternalRetrieval: boolean;
  is31: boolean;
  is51: boolean;
  isRescueTechDiscretion: boolean;
}

// Enums
export enum PortalSize {
  LessThan24 = 2,
  MoreThan24 = 3,
}

export enum PreplanConfiguration {
  RoundOval = 2,
  SquareRectangle = 3,
}
